export default "__VITE_ASSET__C2f6tBjo__"